import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { Sentry } from "./shared/lib/sentry";

Sentry.init();

const rootElement = document.getElementById("root") as HTMLElement;

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
